export const LOAD_CHAT_HISTORY = "LOAD_CHAT_HISTORY";
export const NEW_MESSAGE = "NEW_USER_MESSAGE";
export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const CONNECT = "CONNECT"
export const DISCONNECT = "DISCONNECT";